const versionConfig = {
    version: 'v1.0.1',
    UDIDI: "00850031080225",
    UDIPI: '1.0.1'
}

export default versionConfig